import { render, staticRenderFns } from "./InfoanlassDetails.vue?vue&type=template&id=e79763f6"
import script from "./InfoanlassDetails.vue?vue&type=script&lang=js"
export * from "./InfoanlassDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports